export default __webpack_public_path__ + "static/media/sms_slide5.0130a7b6.jpg";